module.exports = __webpack_public_path__ + "img/agma2001-D04_fig18.6d7dbd2a.png";